import { TipPaymentDTO, PaymentMethodDTO, PaymentDTO, CardTransactionDTO } from 'core/api';
import { PaymentDTOFactory } from '../helpers/payments-processing';

export function createPayment(method: PaymentMethodDTO, tipAmount: number, cardTransaction?: CardTransactionDTO): PaymentDTO {
	return PaymentDTOFactory.create(method, 0, tipAmount, cardTransaction);
}

export function asNewTipPayment(payment: PaymentDTO): TipPaymentDTO {
	return {
		Amount: payment.TipAmount,
		CardTransaction: payment.CardTransaction,
		MethodId: payment.MethodId,
		MethodName: payment.MethodName
	};
}

export function asRefundTipPayment(payment: PaymentDTO): TipPaymentDTO {
	return {
		Amount: -payment.TipAmount,
		CardTransaction: payment.CardTransaction,
		MethodId: payment.MethodId,
		MethodName: payment.MethodName
	};
}

export type AccumulatedTip = { Amount: number, MethodId: number, MethodName: string }

export function getAccumulatedTips(tips: TipPaymentDTO[]): AccumulatedTip[] {
	return tips.groupBy(x => x.MethodId)
		.map(group => ({
			MethodId: group.value[0].MethodId,
			MethodName: group.value[0].MethodName,
			Amount: group.value.sum(x => x.Amount)
		})).filter(t => t.Amount !== 0);
}
